import React from "react";
import emptyStateImage from "../../../../images/new-images/popover-image.png";
import { formatDate } from "../../../Utils/format-date.js";
import { Link } from "react-router-dom";
import "./Welcome.css";
const ResponsiveWelcome = (props) => {
  return (
    <React.Fragment>
      <div className="responsive-Welcome">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={emptyStateImage} alt="empty state image" />
        </div>

        <p className="welcome-text">Welcome Aboard, {props.name}!</p>
        <p className="Complete-Your-Self-Assessment">{props.subtitle}</p>

        <div className="assessment-details">
          <img
            className="assessment-icon"
            src={
              localStorage.getItem("baseLink") +
              `/media/` +
              props.InstrumentImage
            }
            alt="Loi Image"
          />
          <p className="assessment-name">{props.instrumentHeaderText}</p>
        </div>

        {props.assessmentType == "assessment" ? (
          <p className="participant-name">
            {props.name}
            's <span style={{marginLeft:'5px'}}>LOI</span>
          </p>
        ) : (
          <p className="participant-name">
            {props.inviteeName}
            's <span style={{marginLeft:'5px'}}>LOI</span>
          </p>
        )}
        <p className="Expiry-date">Expires On 
       <span style={{marginLeft:'5px'}}> {formatDate(props.expiryDate)} </span></p>
        <Link
          to={{
            pathname: props.startLink,
          }}
          className="view-link"
        >
          <button className="start-button" style={{textTransform:'uppercase'}}>start</button>
        </Link>
      </div>
    </React.Fragment>
  );
};

export default ResponsiveWelcome;



// WEBPACK FOOTER //
// ./src/new/Components/Welcome/Responsive/Welcome.jsx